import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const aiChatMutation = createApi({
  reducerPath: 'aiChatMutation',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    responseHandler: 'text',
  }),
  endpoints: (builder) => ({
    sendChatMessage: builder.mutation<
      { response: string },
      { body: string; from: string }
    >({
      query: ({ body, from }) => ({
        url: '/ai/chat',
        method: 'POST',
        body: JSON.stringify({ Body: body, From: from }),
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }),
      transformResponse: (response: string) => {
        try {
          if (response.startsWith('<?xml')) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(response, 'application/xml');
            return {
              response:
                xmlDoc.querySelector('Message')?.textContent || 'Unknown error',
            };
          }

          return JSON.parse(response);
        } catch (error) {
          console.error('Error parsing response:', error);
          return { response: 'Error parsing server response' };
        }
      },
    }),
  }),
});

export const { useSendChatMessageMutation } = aiChatMutation;
